import type { DashboardSearchRequestDTO } from '../types/search-request.dto';
import type { DashboardSearchRequestModel } from '../types/search-request.model';

export const toSearchRequestDTO = (
	model: DashboardSearchRequestModel
): DashboardSearchRequestDTO => {
	return {
		start_time: model.startTime,
		end_time: model.endTime,
		organization_ids: model.organizationIds,
	};
};
